import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/service-management/components/ServiceManagementInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/AdminSidebar.tsx");
